<template>
    <div class="result">
        <div class="result-content">
            <a href="javascript:void(0)" @click="redo" class="top-link">重新测试</a>
            <h1 class="r-title" v-if="result.quota">恭喜你</h1>
            <h1 class="r-title" v-else>很遗憾</h1>
            <h3 class="r-subtitle" v-if="result.quota">可以获得 <span class="color-red">{{result.quota}}</span> <span v-if="score<95">万元</span>额度的信用卡</h3>
            <h3 class="r-subtitle" v-else>您还没达到银行信用卡的办卡条件</h3>
            <div class="r-desc">*银行会根据申请人填写的多项信息进行综合评分，给予信用卡额度，本额度仅供参考最终额度以银行为准。</div>
            <div class="card-img" :class="result.cardImgClass"></div>
            <div class="card-name">{{result.cardName}}</div>
            <div class="card-desc" v-html="result.cardDesc"></div>
            <div class="btn-area"> <a href="http://m.creditcard.com.cn/apply/action/applyForCreditCard.html?channel=0000022" class="btn btn-default">更多信用卡</a> <a :href="result.redirect" class="btn btn-primary ml1">立即申请</a>
            </div>
        </div>
    </div>
</template>

<script>
import store from './store.js'
export default {
  data () {
    return {
      score: store.score
    }
  },
  computed: {
    result () {
      var cards = {
        bank0: {
          quota: null,
          cardName: '农行乐卡',
          cardImgClass: 'card-img0',
          cardDesc: '申请率高<br/>首年免年费，满5次免次年年费<br/>支持小额快速支付功能，挥卡可付',
          redirect: 'http://lxzl.abchina.com/cards/ApplyStep1?id=47&channel_code=0130'
        },
        bank1: {
          quota: '0.5-1',
          cardName: '农行金穗QQ联名IC信用卡',
          cardImgClass: 'card-img1',
          cardDesc: '终身免年费<br/>同城本行范围内提取超额还款免取现手续费<br/>支持带电子现金应用',
          redirect: 'http://lxzl.abchina.com/cards/ApplyStep1?id=19&channel_code=0130'
        },
        bank2: {
          quota: '1-2',
          cardName: '光大福ic信用卡',
          cardImgClass: 'card-img2',
          cardDesc: '首年免年费<br/>首刷赠10万积分<br/>屈臣氏满200减50',
          redirect: 'https://xyk.cebbank.com/cebmms/apply/fz/card-apply-index.htm?req_card_id=1001&pro_code=FHTG237746SJ01HZWC'
        },
        bank3: {
          quota: '2-3',
          cardName: '中信淘宝网联名卡（v卡）金卡',
          cardImgClass: 'card-img3',
          cardDesc: '剁手族必备，网购超划算<br/>新客户享30元支付宝红包<br/>4小时1000元航班延误险',
          redirect: 'https://creditcard.ecitic.com/citiccard/newwap/pages/AppCreditCard/applayCard-process.html?sid=SJXYKZC&pid=CS0150'
        },
        bank4: {
          quota: '3-4',
          cardName: '平安携程商旅金卡',
          cardImgClass: 'card-img4',
          cardDesc: '同享携程金牌会员<br/>赠高达260万海陆空全方位意外保障<br/>赠全天候国内紧急救援',
          redirect: 'https://c.pingan.com/apply/mobile/apply/index.html?scc=920000135&ccp=5a1a2a3a4a8a9a10a11a12a13&show=0'
        },
        bank5: {
          quota: '4-5',
          cardName: '中信i白金信用卡',
          cardImgClass: 'card-img5',
          cardDesc: '免年费白金卡<br/>IMAX五折观影<br/>网络交易计积分',
          redirect: 'https://creditcard.ecitic.com/citiccard/newwap/pages/AppCreditCard/applayCard-process.html?sid=SJXYKZC&pid=CS0083'
        },
        bank6: {
          quota: '6万以上',
          cardName: '平安保险金卡',
          cardImgClass: 'card-img6',
          cardDesc: '平安保险值得信赖<br/>每年获赠高达130万全方位保障<br/>每年获赠国内急难救援服务',
          redirect: 'https://c.pingan.com/apply/mobile/apply/index.html?scc=920000135&ccp=4a1a2a3a5a8a9a10a11a12a13&show=0'
        }
      }
      switch (!0) {
        case this.score < 25:
          return cards.bank0
        case this.score < 55:
          return cards.bank1
        case this.score < 65:
          return cards.bank2
        case this.score < 75:
          return cards.bank3
        case this.score < 85:
          return cards.bank4
        case this.score < 95:
          return cards.bank5
        case this.score > 95:
          return cards.bank6
      }
    }
  },
  methods: {
    redo () {
      this.$dispatch('redo')
    }
  }
}
</script>

<style scoped>
.result-content{
    position: relative;
    margin: 2rem 1.5rem 5rem;
    padding: 1rem;
    background: url(../assets/result_bg.png) no-repeat;
    background-size: 100% 100%;
    color: #333;
}
.top-link{
    display: inline-block;
    position: absolute;
    right: 1rem;
    font-size: 1.4rem;
    color: #007aff;
    text-decoration: none;
}
.top-link:before{
    display: block;
    float: left;
    content:'';
    background: url(../assets/i-redo.png) no-repeat;
    background-size: 1.2rem 1.2rem;
    width: 1.4rem;
    height: 1.4rem;
}
.r-title{
    text-align: center;
    font-weight: normal;
    font-size: 2rem;
    margin: 2rem 1rem 1rem;
}
.r-subtitle{
    text-align: center;
    font-size: 1.5rem;
    font-weight: normal;
    margin: 1rem;
}
.color-red{
    color:#d94b40;
}
.r-desc{
    color:#8c8c8c;
    font-size: 1rem;
    margin: 0 0.8rem;
}
.card-img{
    margin: 2rem auto 1rem;
    width: 20rem;
    height: 12rem;
    background-size: 100% 100%;
}
.card-img0{
    background-image: url(../assets/bank0-2.png);
}
.card-img1{
    background-image: url(../assets/bank1-1.png);
}
.card-img2{
    background-image: url(../assets/bank2-1.png);
}
.card-img3{
    background-image: url(../assets/bank3-1.png);
}
.card-img4{
    background-image: url(../assets/bank4-1.png);
}
.card-img5{
    background-image: url(../assets/bank5-1.png);
}
.card-img6{
    background-image: url(../assets/bank6-1.png);
}
.card-name{
    text-align: center;
    font-size: 1.5rem;
}
.card-desc{
    text-align: center;
    font-size: 1.2rem;
    color:#8c8c8c;
    margin-top: 1rem;
    line-height: 1.5rem;
}
.btn-area{
    text-align: center;
    margin: 1.5rem auto 2.5rem;
}
.btn-area .btn{
    display: inline-block;
    text-decoration: none;
    font-size: 1.5rem;
    border: 1px solid #d94b40;
    color:#d94b40;
    border-radius: 5px;
}
.btn-default{
    padding: 0.8rem;
}
.btn-primary{
    padding: 0.8rem 3rem;
}
.ml1{
    margin-left: 1rem;
}
</style>


/** WEBPACK FOOTER **
 ** result.vue?0eeeeff2
 **/